import React, { Component } from 'react';
import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import MapaGoogle from '../mapa/mapaGoogle';
import { Marker, InfoWindow, Polyline } from 'react-google-maps';
import { getConfig } from '../configuracao/configLocal';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';
import { coletarPinsFase } from '../fase/mapaFaseMarkerUtils';
import {
  chaveMarcadorControlador,
  mesclarCadastroControlador,
  renderMarcadoresControlador,
} from '../fase/mapaControladorMap';
import MapaControladorGaveta from '../fase/mapaControladorGaveta';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import { executarResetControlador } from '../fase/mapaControladorCadastro';
import { MapaWazeInfoAlerta, MapaWazeInfoJam, MapaWazeInfoFase } from './mapaWazeInfo';

const PIN_ALERTA = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
const INTERVALO_WAZE_MS = 45 * 1000;
const INTERVALO_FASES_MS = 1000;
const BLINK_MS = 500;
const ZOOM_FOCO_CRUZAMENTO = 17;
const REACT_GOOGLE_MAP_CTX = '__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED';

/** Ref do react-google-maps expõe panTo/getZoom, mas não setZoom — usa a instância nativa. */
function definirZoomMinimoMapa(mapRef, zoomMin) {
  if (!mapRef) return null;
  const atual = typeof mapRef.getZoom === 'function' ? mapRef.getZoom() : null;
  const zoom = Math.max(Number.isFinite(atual) ? atual : 0, zoomMin);
  if (typeof mapRef.setZoom === 'function') {
    mapRef.setZoom(zoom);
    return zoom;
  }
  const nativo = mapRef.context && mapRef.context[REACT_GOOGLE_MAP_CTX];
  if (nativo && typeof nativo.setZoom === 'function') {
    nativo.setZoom(zoom);
    return zoom;
  }
  return Number.isFinite(atual) ? atual : zoomMin;
}

const GRUPO_SELECT_STYLE = {
  padding: '4px 8px',
  fontSize: '12px',
  minWidth: '168px',
  height: '30px',
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
};

function formatarData(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function tituloControladorImpacto(c) {
  const num =
    c.numero_controlador != null && c.numero_controlador !== ''
      ? c.numero_controlador
      : c.controlador_id;
  return `Controlador ${num}`;
}

function subtituloCruzamentoImpacto(c) {
  const cruz = c.cruzamento && String(c.cruzamento).trim();
  if (cruz) return cruz;
  const end = c.endereco && String(c.endereco).trim();
  return end || null;
}

function rotuloImpacto(c) {
  if (c.tem_via_fechada || c.impacto === 'via_fechada') return 'Via fechada';
  const map = {
    alto: 'Congestionamento alto',
    moderado: 'Congestionamento moderado',
    leve: 'Congestionamento leve',
    alerta: 'Alerta Waze próximo',
  };
  return map[c.impacto] || c.impacto;
}

class MapaWaze extends Component {
  constructor(props) {
    super(props);
    const grupoInicial = parseInt(getConfig('grupo'), 10) || 0;
    this.state = {
      loading: true,
      erro: null,
      naoConfigurado: false,
      dados: null,
      googleMapsReady: typeof window !== 'undefined' && !!(window.google && window.google.maps),
      markerAberto: null,
      exibirAlertas: true,
      exibirJams: true,
      exibirFases: true,
      grupoFisico: grupoInicial,
      fasesList: [],
      controladoresList: [],
      leituraFasesAoVivo: false,
      gavetaControlador: null,
      resetControladorAlvo: null,
      mapZoom: 13,
      blinkOn: true,
    };
    this.mapRef = null;
    this.intervalWaze = null;
    this.intervalFases = null;
    this.blinkInterval = null;
    this.carregarMapa = this.carregarMapa.bind(this);
    this.carregarFases = this.carregarFases.bind(this);
    this.iniciarPollingFases = this.iniciarPollingFases.bind(this);
    this.pararPollingFases = this.pararPollingFases.bind(this);
    this.onMapLoad = this.onMapLoad.bind(this);
    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.abrirMarker = this.abrirMarker.bind(this);
    this.fecharMarker = this.fecharMarker.bind(this);
    this.renderConteudoMapa = this.renderConteudoMapa.bind(this);
    this.toggleCamada = this.toggleCamada.bind(this);
    this.onGrupoChange = this.onGrupoChange.bind(this);
    this.focarCruzamento = this.focarCruzamento.bind(this);
    this.mapaImpactoPorControlador = this.mapaImpactoPorControlador.bind(this);
    this.carregarControladores = this.carregarControladores.bind(this);
    this.toggleLeituraFases = this.toggleLeituraFases.bind(this);
    this.handleDetalhesControlador = this.handleDetalhesControlador.bind(this);
    this.fecharGavetaControlador = this.fecharGavetaControlador.bind(this);
    this.solicitarResetControlador = this.solicitarResetControlador.bind(this);
    this.confirmarResetControlador = this.confirmarResetControlador.bind(this);
    this.cancelarResetControlador = this.cancelarResetControlador.bind(this);
  }

  componentDidMount() {
    this.carregarMapa();
    this.intervalWaze = setInterval(this.carregarMapa, INTERVALO_WAZE_MS);
    this.blinkInterval = setInterval(() => {
      this.setState(prev => ({ blinkOn: !prev.blinkOn }));
    }, BLINK_MS);

    if (this.state.grupoFisico > 0) {
      this.carregarControladores();
    }

    if (!this.state.googleMapsReady) {
      this.googleMapsReadyInterval = setInterval(() => {
        if (typeof window !== 'undefined' && window.google && window.google.maps) {
          clearInterval(this.googleMapsReadyInterval);
          this.googleMapsReadyInterval = null;
          this.setState({ googleMapsReady: true });
        }
      }, 300);
    }
  }

  componentWillUnmount() {
    if (this.intervalWaze) clearInterval(this.intervalWaze);
    this.pararPollingFases();
    if (this.blinkInterval) clearInterval(this.blinkInterval);
    if (this.googleMapsReadyInterval) clearInterval(this.googleMapsReadyInterval);
  }

  onGrupoChange(valor) {
    const grupo = parseInt(valor, 10);
    this.pararPollingFases();
    if (!grupo) {
      this.setState({
        grupoFisico: 0,
        fasesList: [],
        controladoresList: [],
        leituraFasesAoVivo: false,
        gavetaControlador: null,
      });
      return;
    }

    this.setState({ grupoFisico: grupo, fasesList: [], leituraFasesAoVivo: false, gavetaControlador: null }, () => {
      this.carregarControladores();
    });
  }

  carregarControladores() {
    const { grupoFisico } = this.state;
    if (!grupoFisico) return;

    axiosInstance
      .get(`/fasesgeral/mapa/controladores/${grupoFisico}`)
      .then(resp => {
        this.setState({ controladoresList: resp.data || [] });
      })
      .catch(() => {
        toastr.warning('Mapa Waze', 'Não foi possível carregar controladores do grupo.');
      });
  }

  toggleLeituraFases() {
    const { leituraFasesAoVivo, grupoFisico } = this.state;
    if (leituraFasesAoVivo) {
      this.pararPollingFases();
      this.setState({ leituraFasesAoVivo: false, fasesList: [], markerAberto: null }, () => {
        this.carregarControladores();
      });
      return;
    }

    if (!grupoFisico) {
      toastr.warning('Mapa Waze', 'Selecione um grupo físico para iniciar a leitura das fases.');
      return;
    }

    this.setState({ leituraFasesAoVivo: true, markerAberto: null }, () => this.iniciarPollingFases());
  }

  handleDetalhesControlador(c) {
    this.setState({
      gavetaControlador: c,
      markerAberto: null,
    });
  }

  fecharGavetaControlador() {
    this.setState({ gavetaControlador: null });
  }

  solicitarResetControlador(c) {
    this.setState({ resetControladorAlvo: c });
  }

  confirmarResetControlador() {
    const c = this.state.resetControladorAlvo;
    this.setState({ resetControladorAlvo: null });
    if (!c) return;
    executarResetControlador(c);
  }

  cancelarResetControlador() {
    this.setState({ resetControladorAlvo: null });
  }

  impactoDoControlador(controladorId) {
    return this.mapaImpactoPorControlador().get(Number(controladorId));
  }

  pararPollingFases() {
    if (this.intervalFases) {
      clearInterval(this.intervalFases);
      this.intervalFases = null;
    }
  }

  iniciarPollingFases() {
    const { grupoFisico } = this.state;
    if (!grupoFisico) return;

    this.pararPollingFases();
    this.carregarFases();
    this.intervalFases = setInterval(this.carregarFases, INTERVALO_FASES_MS);
  }

  carregarFases() {
    const { grupoFisico } = this.state;
    if (!grupoFisico) return;

    axiosInstance
      .get(`/fasesgeral/mapagf/${grupoFisico}`)
      .then(resp => {
        this.setState({ fasesList: resp.data || [] });
      })
      .catch(err => {
        if (err.response && err.response.status === 503) return;
        const msg =
          (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]) ||
          'Erro ao carregar fases.';
        toastr.warning('Mapa Waze', msg);
      });
  }

  carregarMapa() {
    this.setState({ loading: true, erro: null });

    axiosInstance
      .get('/waze/mapa')
      .then(resp => {
        this.setState({
          dados: resp.data,
          loading: false,
          naoConfigurado: false,
          erro: null,
        });
      })
      .catch(err => {
        const status = err.response && err.response.status;
        const message = (err.response && err.response.data && err.response.data.message) || 'Erro ao carregar dados Waze.';

        if (status === 503) {
          this.setState({ loading: false, naoConfigurado: true, erro: message, dados: null });
          return;
        }

        toastr.error('Waze', message);
        this.setState({ loading: false, erro: message, dados: null });
      });
  }

  onMapLoad(map) {
    this.mapRef = map;
    if (map && map.getZoom) {
      this.setState({ mapZoom: map.getZoom() });
    }
  }

  onZoomChanged(zoom) {
    if (Number.isFinite(zoom)) this.setState({ mapZoom: zoom });
  }

  abrirMarker(id) {
    this.setState({ markerAberto: id });
  }

  fecharMarker() {
    this.setState({ markerAberto: null });
  }

  toggleCamada(campo) {
    this.setState(prev => ({ [campo]: !prev[campo] }));
  }

  mapaImpactoPorControlador() {
    const { dados } = this.state;
    const map = new Map();
    (dados && dados.cruzamentos ? dados.cruzamentos : []).forEach(c => {
      map.set(Number(c.controlador_id), c);
      if (c.numero_controlador != null && c.numero_controlador !== '') {
        map.set(Number(c.numero_controlador), c);
      }
    });
    return map;
  }

  fasesDoCruzamentoImpacto(c) {
    const { fasesList, grupoFisico } = this.state;
    return fasesList.filter(f => {
      if (grupoFisico > 0 && Number(f.grupo_fisico_id) !== grupoFisico) return false;
      if (c.numero_controlador != null && c.numero_controlador !== '') {
        return Number(f.numero_controlador) === Number(c.numero_controlador);
      }
      return Number(f.controlador_id) === Number(c.controlador_id);
    });
  }

  focarCruzamento(c) {
    const { mapZoom, blinkOn, leituraFasesAoVivo } = this.state;

    if (!leituraFasesAoVivo) {
      const merged = mesclarCadastroControlador(c, this.state.controladoresList);
      const latCtrl = Number.isFinite(merged.latitude) ? merged.latitude : null;
      const lngCtrl = Number.isFinite(merged.longitude) ? merged.longitude : null;
      let mapZoomAposFoco = mapZoom;
      if (this.mapRef && latCtrl != null && lngCtrl != null) {
        this.mapRef.panTo({ lat: latCtrl, lng: lngCtrl });
        const zoom = definirZoomMinimoMapa(this.mapRef, ZOOM_FOCO_CRUZAMENTO);
        if (Number.isFinite(zoom)) mapZoomAposFoco = zoom;
      }
      this.setState({
        exibirFases: true,
        markerAberto: chaveMarcadorControlador(merged),
        mapZoom: mapZoomAposFoco,
        gavetaControlador: merged,
      });
      return;
    }

    const fasesCtrl = this.fasesDoCruzamentoImpacto(c);
    const pins = coletarPinsFase(fasesCtrl, { mapZoom, blinkOn });
    let pin = null;
    if (c.numero_controlador != null && c.numero_controlador !== '') {
      pin = pins.find(p => Number(p.data.numero_controlador) === Number(c.numero_controlador));
    }
    if (!pin) pin = pins.find(p => Number(p.controlador_id) === Number(c.controlador_id));
    if (!pin) pin = pins[0];

    const latFoco = Number.isFinite(c.latitude) ? c.latitude : pin && pin.position.lat;
    const lngFoco = Number.isFinite(c.longitude) ? c.longitude : pin && pin.position.lng;

    let mapZoomAposFoco = mapZoom;
    if (this.mapRef && Number.isFinite(latFoco) && Number.isFinite(lngFoco)) {
      this.mapRef.panTo({ lat: latFoco, lng: lngFoco });
      const zoom = definirZoomMinimoMapa(this.mapRef, ZOOM_FOCO_CRUZAMENTO);
      if (Number.isFinite(zoom)) mapZoomAposFoco = zoom;
    }

    this.setState({
      exibirFases: true,
      markerAberto: pin ? `fase:${pin.key}` : null,
      mapZoom: mapZoomAposFoco,
    });
  }

  getCentroExibicao() {
    const { dados } = this.state;
    if (dados && dados.centro) return dados.centro;
    return null;
  }

  renderMarcadoresAlerta() {
    const { dados, markerAberto, exibirAlertas } = this.state;
    if (!exibirAlertas || !dados || !dados.alertas) return null;

    return dados.alertas.map(alerta => {
      const id = `alerta:${alerta.id}`;
      return (
        <Marker
          key={alerta.id}
          position={{ lat: alerta.latitude, lng: alerta.longitude }}
          icon={PIN_ALERTA}
          onClick={() => this.abrirMarker(id)}
          zIndex={3}
        >
          {markerAberto === id && (
            <InfoWindow onCloseClick={this.fecharMarker}>
              <MapaWazeInfoAlerta alerta={alerta} formatarData={formatarData} />
            </InfoWindow>
          )}
        </Marker>
      );
    });
  }

  renderMarcadoresControlador() {
    const { exibirFases, controladoresList, markerAberto } = this.state;
    if (!exibirFases || !controladoresList.length) return null;

    return renderMarcadoresControlador({
      controladores: controladoresList,
      markerAberto,
      onAbrir: this.abrirMarker,
      onFechar: this.fecharMarker,
      onDetalhes: this.handleDetalhesControlador,
      onReset: this.solicitarResetControlador,
      impactoPorControladorId: this.mapaImpactoPorControlador(),
    });
  }

  renderMarcadoresFase() {
    const { exibirFases, fasesList, mapZoom, blinkOn, markerAberto, leituraFasesAoVivo } = this.state;
    if (!exibirFases) return null;

    if (!leituraFasesAoVivo) {
      return this.renderMarcadoresControlador();
    }

    if (!fasesList.length) return null;

    const impactoMap = this.mapaImpactoPorControlador();
    const pins = coletarPinsFase(fasesList, { mapZoom, blinkOn });

    return pins.map(pin => {
      const id = `fase:${pin.key}`;
      const impacto = impactoMap.get(Number(pin.controlador_id));
      return (
        <Marker
          key={id}
          position={pin.position}
          icon={pin.icon}
          shape={pin.shape}
          onClick={() => this.abrirMarker(id)}
          zIndex={impacto && impacto.impacto ? 4 : 2}
        >
          {markerAberto === id && (
            <InfoWindow onCloseClick={this.fecharMarker}>
              <MapaWazeInfoFase fase={pin.data} impactoCruzamento={impacto} />
            </InfoWindow>
          )}
        </Marker>
      );
    });
  }

  jamAberto() {
    const { dados, markerAberto } = this.state;
    if (!markerAberto || !markerAberto.startsWith('jam:') || !dados || !dados.congestionamentos) return null;
    const jamId = markerAberto.slice(4);
    return dados.congestionamentos.find(j => String(j.id) === String(jamId)) || null;
  }

  renderCongestionamentos() {
    const { dados, exibirJams } = this.state;
    if (!exibirJams || !dados || !dados.congestionamentos) return null;

    return dados.congestionamentos.map(jam => (
      <Polyline
        key={jam.id}
        path={jam.path}
        options={{
          strokeColor: jam.cor,
          strokeOpacity: 0.85,
          strokeWeight: 6,
          clickable: true,
        }}
        onClick={() => this.abrirMarker(`jam:${jam.id}`)}
      />
    ));
  }

  renderInfoJamFlutuante() {
    const { dados } = this.state;
    const jam = this.jamAberto();
    if (!jam || !jam.path || !jam.path.length) return null;
    const pos = jam.path[Math.floor(jam.path.length / 2)];
    const feedLidoEm = dados && dados.atualizado_em ? dados.atualizado_em : null;
    return (
      <InfoWindow position={pos} onCloseClick={this.fecharMarker}>
        <MapaWazeInfoJam jam={jam} feedLidoEm={feedLidoEm} formatarData={formatarData} />
      </InfoWindow>
    );
  }

  renderConteudoMapa() {
    const { googleMapsReady, loading, erro, naoConfigurado, dados } = this.state;
    const centro = this.getCentroExibicao();

    if (!googleMapsReady) {
      return (
        <div className="mapa-fases-premium-empty mapa-waze-empty">
          <div>
            <i className="fa fa-spinner fa-spin" />
            <h4>Carregando Google Maps</h4>
          </div>
        </div>
      );
    }

    if (naoConfigurado) {
      return (
        <div className="mapa-fases-premium-empty mapa-waze-empty">
          <div>
            <i className="fa fa-link" />
            <h4>Feed Waze não configurado</h4>
            <p>
              Informe <code>waze_feed_url</code> no <code>environments.js</code> do cliente (Partner Hub → Feed JSON).
            </p>
          </div>
        </div>
      );
    }

    if (loading && !dados) {
      return (
        <div className="mapa-fases-premium-empty mapa-waze-empty">
          <div>
            <i className="fa fa-spinner fa-spin" />
            <h4>Carregando mapa Waze</h4>
            <p>Buscando alertas e congestionamentos do feed…</p>
          </div>
        </div>
      );
    }

    if (erro && !dados) {
      return (
        <div className="mapa-fases-premium-empty mapa-waze-empty">
          <div>
            <i className="fa fa-exclamation-triangle" />
            <h4>Erro ao carregar Waze</h4>
            <p>{erro}</p>
          </div>
        </div>
      );
    }

    if (!centro) {
      return (
        <div className="mapa-fases-premium-empty mapa-waze-empty">
          <div>
            <i className="fa fa-map-marked-alt" />
            <h4>Sem referência de mapa</h4>
            <p>Configure <code>waze_map_center_lat/lng</code> ou aguarde alertas no feed.</p>
          </div>
        </div>
      );
    }

    return (
      <>
        {loading && (
          <div className="mapa-os-premium-loading">
            <i className="fa fa-spinner fa-spin" />
          </div>
        )}
        <MapaGoogle
          containerElement={<div style={{ height: '100%', width: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          defaultCenter={{ lat: centro.lat, lng: centro.lng }}
          defaultZoom={13}
          onMapLoad={this.onMapLoad}
          onZoomChanged={this.onZoomChanged}
        >
          {this.renderCongestionamentos()}
          {this.renderMarcadoresAlerta()}
          {this.renderMarcadoresFase()}
          {this.renderInfoJamFlutuante()}
        </MapaGoogle>
      </>
    );
  }

  listaImpactadosFiltrada() {
    const { dados, grupoFisico } = this.state;
    if (!grupoFisico || grupoFisico <= 0) return [];
    const lista = (dados && dados.cruzamentos_impactados) || [];
    return lista.filter(c => Number(c.grupo_fisico_id) === grupoFisico);
  }

  renderListaImpactados() {
    const { grupoFisico } = this.state;
    if (!grupoFisico || grupoFisico <= 0) {
      return (
        <p className="mapa-waze-side-empty">
          Selecione um grupo físico para listar os cruzamentos impactados desse grupo.
        </p>
      );
    }

    const lista = this.listaImpactadosFiltrada();
    if (!lista.length) {
      return (
        <p className="mapa-waze-side-empty">
          Nenhum cruzamento deste grupo perto de filas ou alertas Waze.
        </p>
      );
    }

    return (
      <ul className="mapa-waze-impact-list">
        {lista.map(c => {
          const cruzamentoSub = subtituloCruzamentoImpacto(c);
          return (
            <li
              key={`${c.grupo_fisico_id != null ? c.grupo_fisico_id : 'g'}-${
                c.numero_controlador != null ? c.numero_controlador : c.controlador_id
              }`}
            >
              <button type="button" className="mapa-waze-impact-item" onClick={() => this.focarCruzamento(c)}>
                <span className="mapa-waze-impact-title">{tituloControladorImpacto(c)}</span>
                {cruzamentoSub ? <span className="mapa-waze-impact-sub">{cruzamentoSub}</span> : null}
                <span className={`mapa-waze-impact-meta${c.impacto === 'alto' ? ' is-alto' : ''}`}>
                  {rotuloImpacto(c)}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    );
  }

  render() {
    const { dados, loading, exibirAlertas, exibirJams, exibirFases, grupoFisico, leituraFasesAoVivo } = this.state;
    const resumo = (dados && dados.resumo) || {};
    const cruzamentosImpactadosGrupo = grupoFisico > 0 ? this.listaImpactadosFiltrada().length : null;

    return (
      <div className="mapa-fases-premium mapa-os-premium mapa-waze-premium">
        <div className="mapa-fases-premium-toolbar mapa-waze-header-bar">
          <div className="mapa-waze-header mapa-waze-header--compact">
            <h2 className="mapa-waze-title">Mapa Waze</h2>
            <div className="mapa-waze-stat-bar" aria-label="Resumo Waze">
              <span className="mapa-waze-stat">
                <strong>{resumo.alertas || 0}</strong> alertas
              </span>
              <span className="mapa-waze-stat">
                <strong>{resumo.congestionamentos || 0}</strong> filas
              </span>
              <span
                className="mapa-waze-stat mapa-waze-stat--accent"
                title={grupoFisico > 0 ? undefined : 'Selecione um grupo físico para contar cruzamentos afetados'}
              >
                <strong>{cruzamentosImpactadosGrupo != null ? cruzamentosImpactadosGrupo : '—'}</strong> cruz. afetados
              </span>
              {dados && dados.atualizado_em ? (
                <span className="mapa-waze-stat mapa-waze-stat--muted">{formatarData(dados.atualizado_em)}</span>
              ) : null}
            </div>
            <div className="mapa-waze-header-tools">
              <SelectConfGrupoFisico customStyle={GRUPO_SELECT_STYLE} onChange={this.onGrupoChange} />
              <button
                type="button"
                className={`mapa-waze-pill mapa-waze-pill--live ${leituraFasesAoVivo ? 'is-active' : ''}`}
                onClick={this.toggleLeituraFases}
                disabled={!grupoFisico}
                title={
                  grupoFisico
                    ? leituraFasesAoVivo
                      ? 'Pausar leitura das fases SSAT'
                      : 'Iniciar leitura ao vivo das fases (grupo inteiro)'
                    : 'Selecione um grupo físico'
                }
              >
                <i className={`fa ${leituraFasesAoVivo ? 'fa-pause' : 'fa-play'}`} />{' '}
                {leituraFasesAoVivo ? 'Pausar fases' : 'Iniciar fases'}
              </button>
              <div className="mapa-waze-layer-pills" role="group" aria-label="Camadas do mapa">
                <button
                  type="button"
                  className={`mapa-waze-pill ${exibirJams ? 'is-active' : ''}`}
                  onClick={() => this.toggleCamada('exibirJams')}
                >
                  Filas
                </button>
                <button
                  type="button"
                  className={`mapa-waze-pill ${exibirAlertas ? 'is-active' : ''}`}
                  onClick={() => this.toggleCamada('exibirAlertas')}
                >
                  Alertas
                </button>
                <button
                  type="button"
                  className={`mapa-waze-pill ${exibirFases ? 'is-active' : ''}`}
                  onClick={() => this.toggleCamada('exibirFases')}
                >
                  Fases
                </button>
              </div>
              <button
                type="button"
                className="mapa-waze-refresh-btn mapa-waze-refresh-btn--icon"
                onClick={this.carregarMapa}
                disabled={loading}
                title="Atualizar dados Waze"
                aria-label="Atualizar dados Waze"
              >
                <i className={`fa fa-sync-alt ${loading ? 'fa-spin' : ''}`} />
              </button>
            </div>
          </div>
        </div>

        <div className="mapa-fases-premium-content mapa-waze-content-wrap">
          <div className="mapa-waze-layout">
            <div className="mapa-fases-premium-map-card mapa-os-premium-map-card mapa-waze-map-flex">{this.renderConteudoMapa()}</div>
            <aside className="mapa-waze-sidebar">
              <h3>Cruzamentos impactados</h3>
              <p className="mapa-waze-side-hint">Filas ~200 m · alertas ~120 m dos semáforos cadastrados</p>
              {this.renderListaImpactados()}
            </aside>
          </div>
        </div>

        {this.state.gavetaControlador ? (
          <MapaControladorGaveta
            controlador={this.state.gavetaControlador}
            grupoFisicoId={this.state.grupoFisico || this.state.gavetaControlador.grupo_fisico_id}
            googleMapsReady={this.state.googleMapsReady}
            impactoCruzamento={this.impactoDoControlador(this.state.gavetaControlador.controlador_id)}
            onClose={this.fecharGavetaControlador}
          />
        ) : null}

        <ActionConfirmModal
          show={!!this.state.resetControladorAlvo}
          title="Atenção"
          message="Deseja resetar o controlador?"
          confirmLabel="OK"
          icon="exclamation-triangle"
          destructive
          onConfirm={this.confirmarResetControlador}
          onCancel={this.cancelarResetControlador}
        />
      </div>
    );
  }
}

export default MapaWaze;
